import DeviceConfig from '@devices/config';
import PhotoDefault from '../../../../shared/assets/images/png/photoDefault.png';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';

const DescriptionBackground = styled.img<React.CSSProperties>`
  position: absolute;
  height: ${570 * Screen.widthRatio}px;
  width: ${1018 * Screen.widthRatio}px;
  left: ${(880 + 1) * Screen.widthRatio}px;
  top: 0px;
  ${() => {
    return DeviceConfig.capabilities?.image?.disableFitCover
      ? ''
      : 'object-fit:cover';
  }};
`;

export default withImage(DescriptionBackground, true, PhotoDefault);
